"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectStatus = void 0;
/**
 * Project Status Enum
 *
 * Represents the status of a craft project.
 * Used in craft project database records, API request/response types,
 * and display types.
 *
 * Consumers: lambda-secure, free-pattern-warehouse-website
 */
var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["NOT_STARTED"] = "not_started";
    ProjectStatus["IN_PROGRESS"] = "in_progress";
    ProjectStatus["COMPLETED"] = "completed";
    ProjectStatus["PAUSED"] = "paused";
    ProjectStatus["ABANDONED"] = "abandoned";
})(ProjectStatus || (exports.ProjectStatus = ProjectStatus = {}));
